import React, {useState, useEffect, useRef} from "react";
import { useParams } from "react-router-dom";
import collectionsService from "../../../../services/collections-service";
import Footer from "../Common/Footer/Footer";
import Header from "../Common/Header/Header";
import CollectionsListView from "./CollectionsListView";
import Spinner from "../../../../shared/Spinner";

export default function CollectionsList() {
    const {id} = useParams()
    const color = '#a2a2a2';
    const [spinner, setSpinner] = useState(false);
    const [products, setProducts] = useState([]);
    const [filterOptions, setFilterOptions] = useState([]);
    const [filtersTable, setFiltersTable] = useState({});
    const [sorted, setSorted] = useState({
        sortBy : "p.id", order: 'desc'
    });
    let start = useRef(0);
    let totalRecord = 0;
    let isLoading = false;

    useEffect(async ()=>{
        setSpinner(true);
        getProducts(start.current,false,sorted);
    },[id])

    const getProducts=async(body,filter,order) =>{
        start.current = (!filter) ? body: 0;
        isLoading = true;
        const res = await collectionsService.getCollectionsByCol({
            start: body, id: id, filter: filterOptions, sortBy: order.sortBy, order: order.order
        });
        if(!filter){
            setProducts((products) => ([...products,...res.data.products]));
        }else{
            setProducts(res.data.products);
        }
        setFiltersTable(res.data.filtersTable);
        totalRecord = parseInt(res.data.count[0].count);
        isLoading = false;
        setSpinner(false);
    }

    const handleFilter=async(key,value,name)=>{
        setSpinner(true);
        let options = filterOptions;
        options.map((x,y)=>{
            let findKey = Object.keys(x);
            if(findKey[0] === key){
                options.splice(y, 1)
            }
        })
        options.push({[key]: value, name: name})
        setFilterOptions([...options]);
        getProducts(0,true,sorted);
    }

    const handleDelete=async(item)=>{
        setSpinner(true);
        let options = filterOptions;
        options.splice(options.findIndex(function(i){
            return i.name === item.name;
        }), 1);
        setFilterOptions([...options]);
        getProducts(0,true,sorted);
    }

    const handleSorted = (el) =>{
        console.log(el);
        let obj = {}
        if(el === 0){
            obj={
                sortBy : "p.id", order: 'desc'
            }
        }else if(el === 1){
            obj={
                sortBy : "p.id", order: 'asc'
            }
        }else if(el === 2){
            obj={
                sortBy : "p.pro_price", order: 'asc'
            }
        }else if(el === 3){
            obj={
                sortBy : "p.pro_price", order: 'desc'
            }
        }
        setSorted(obj);
        getProducts(0,true,obj);
    }

    const clearFilter = async () =>{
        setFilterOptions([...[]]);
        setSpinner(true);
        getProducts(start.current,false,sorted);
    }

    const bottomReached = () => {
        let body = parseInt(start.current)+8
        if(!isLoading && totalRecord > body){
            getProducts(body,false,sorted);
        }
    };

    return (
        <>
            <Header 
                color={color}
            />
            <CollectionsListView
                products = {products}
                filtersTable = {filtersTable}
                filterOptions = {filterOptions}
                isLoading = {isLoading}
                id = {id}

                handleFilter = {(key,value,name)=>handleFilter(key,value,name)}
                clearFilter = {()=>clearFilter()}
                handleDelete = {(item)=>handleDelete(item)}
                handleSorted = {(item)=>handleSorted(item)}
                bottomReached = {()=>bottomReached()}
            />
            <Footer />
            <Spinner
                spinner = {spinner}
            />
        </>
    );
}
